import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=22adb878&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22adb878')) {
      api.createRecord('22adb878', component.options)
    } else {
      api.reload('22adb878', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=22adb878&", function () {
      api.rerender('22adb878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cw9q0kjUAE7z/JS/pricehelp.vue"
export default component.exports